import { apiClient } from "@/lib/api-client";
import type { Track, TrackStatus, TrackType } from "@/types/track";
import type { ServicePriority } from "@/types/service-priority";
import type { ServiceExecutionStatus } from "@/types/service-execution-status";
import type { Mechanic } from "@/types/mechanic";

interface OccupyTrackPayload {
  trackId: string;
  workOrderId: string;
  mechanicId?: string;
  note?: string;
  overridePriority?: ServicePriority;
  forceOverride?: boolean;
}

interface ReleaseTrackPayload {
  reason?: string;
  nextExecutionStatus?: ServiceExecutionStatus;
  enqueueInQueue?: boolean;
}

interface UpdateWorkOrderPriorityPayload {
  priority: ServicePriority;
  reason?: string;
}

export async function listTracks() {
  const response = await apiClient.get<Track[]>("/pistas");
  return response.data;
}

export async function listTrackMechanics() {
  const response = await apiClient.get<Mechanic[]>("/pistas/mecanicos");
  return response.data;
}

export async function occupyTrack(payload: OccupyTrackPayload) {
  const response = await apiClient.post<Track>("/pistas/ocupar", payload);
  return response.data;
}

export async function createTrack(payload: { name: string; type: TrackType; status?: TrackStatus; mechanicId?: string | null }) {
  const response = await apiClient.post<Track>("/pistas", payload);
  return response.data;
}

export async function updateTrack(
  trackId: string,
  payload: Partial<{ name: string; type: TrackType; mechanicId?: string | null; status: TrackStatus }>,
) {
  const response = await apiClient.patch<Track>(`/pistas/${trackId}`, payload);
  return response.data;
}

export async function deleteTrack(trackId: string) {
  await apiClient.delete(`/pistas/${trackId}`);
}

export async function releaseTrack(
  trackId: string,
  payload: ReleaseTrackPayload,
) {
  const response = await apiClient.patch<Track>(
    `/pistas/${trackId}/liberar`,
    payload,
  );
  return response.data;
}

export async function updateWorkOrderPriority(
  workOrderId: string,
  payload: UpdateWorkOrderPriorityPayload,
) {
  const response = await apiClient.patch(`/ordens-servico/${workOrderId}/prioridade`, payload);
  return response.data;
}
